var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{class:'mBottom ' + _vm.classType},[(_vm.classType=='light')?_c('img',{staticClass:"corange",attrs:{"src":require("@/assets/img/Group 138@3x.png"),"alt":""}}):_c('img',{staticClass:"corange",attrs:{"src":require("@/assets/img/Group 138-2@3x.png"),"alt":""}}),_vm._v(" "),_c('p',[_vm._v("粤ICP备2022095222号-1")])])}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-3ce57028","hasScoped":true,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/base/mobile/mBottom.vue
// module id = null
// module chunks = 